import React from 'react'

const ReveiwParameters = () => {
    return (
        <div>
            ReveiwParameters
        </div>
    )
}

export default ReveiwParameters
